
var Model = require("../types/Model.js");
// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;

module.exports = new Model({
	name: "theme",
	init: init,
	triggers: triggers
});

function init() {
	return AsyncStorage.getItem("theme").then(function(theme){
		if (!theme) {
			theme = "ae-theme-contrast";
			AsyncStorage.setItem("theme", theme);
		}
		this.push(theme);
	}.bind(this));
}

function triggers() {
	// An imperative message from the 'about.html' UI causes the theme to toggle
	return {
		"contrast": handle_theme_change
	};
}

function handle_theme_change(data) {

	// whatever the theme is, change it.
	var theme = data.theme;
	if (theme === "ae-theme-pretty") {
		theme = "ae-theme-contrast";
	} else {
		theme = "ae-theme-pretty";
	}
	this.emit("usermetrics:trigger:track", `change theme to ${theme}`);
	AsyncStorage.setItem("theme", theme);
	this.push(theme);
}
